import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RatesProvider } from "@/context/RatesContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { RecentlyViewedProvider } from "@/context/RecentlyViewedContext";
import { SolitaireSettingsProvider } from "@/context/SolitaireSettingsContext";
import Navbar from "@/components/Navbar";
import RateBanner from "@/components/RateBanner";
import WishlistDrawer from "@/components/WishlistDrawer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import BackToTop from "@/components/BackToTop";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Catalogue from "@/pages/Catalogue";
import Solitaires from "@/pages/Solitaires";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminInventory from "@/pages/AdminInventory";
import AdminEnquiries from "@/pages/AdminEnquiries";
import AdminSettings from "@/pages/AdminSettings";
import AdminSolitaires from "@/pages/AdminSolitaires";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AITools from "@/pages/AITools";
import PrintTagPage from "@/pages/PrintTag";
import PrintSolitaire from "@/pages/PrintSolitaire";

const ProtectedAdmin = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="admin-shell flex items-center justify-center text-ivory/60">Loading…</div>;
  if (!user) return <Navigate to="/admin" replace />;
  return <div className="admin-shell"><AdminLayout /></div>;
};

const PublicLayout = () => (
  <div className="public-page">
    <Navbar />
    <RateBanner />
    <main className="min-h-[60vh]"><Outlet /></main>
    <Footer />
    <WishlistDrawer />
    <FloatingWhatsApp />
    <BackToTop />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <RatesProvider>
        <WishlistProvider>
          <RecentlyViewedProvider>
            <SolitaireSettingsProvider>
            <BrowserRouter>
              <Toaster richColors position="top-center" theme="dark" toastOptions={{ style: { background: "#131826", border: "1px solid rgba(227,168,156,0.3)", color: "#FDFBF7" } }} />
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Landing />} />
                  <Route path="/catalogue" element={<Catalogue />} />
                  <Route path="/ringstudio" element={<Catalogue />} />
                  <Route path="/solitaires" element={<Solitaires />} />
                  <Route path="/ai-tools" element={<AITools />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                </Route>
                <Route path="/admin" element={<AdminLogin />} />
                <Route element={<ProtectedAdmin />}>
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/inventory" element={<AdminInventory />} />
                  <Route path="/admin/solitaires" element={<AdminSolitaires />} />
                  <Route path="/admin/enquiries" element={<AdminEnquiries />} />
                  <Route path="/admin/settings" element={<AdminSettings />} />
                </Route>
                <Route path="/print-tag/:tag_no" element={<PrintTagPage />} />
                <Route path="/print-solitaire/:stock_id" element={<PrintSolitaire />} />
              </Routes>
            </BrowserRouter>
            </SolitaireSettingsProvider>
          </RecentlyViewedProvider>
        </WishlistProvider>
      </RatesProvider>
    </AuthProvider>
  );
}

export default App;
